const dateFormatter = function (date) {
  let formattedDate = null

  var unformattedDate = new Date(date)

  formattedDate = ('0' + unformattedDate.getDate()).slice(-2) + '.' + ('0' + (unformattedDate.getMonth() + 1)).slice(-2) + '.' + unformattedDate.getFullYear()
  return formattedDate
}
const dateToMonthYearFormatter = function (date) {
  const unformattedDate = new Date(date)
  return unformattedDate.toLocaleString('de', { month: 'long' }) + (' ') + (unformattedDate.getFullYear() - 2000)
}
export { dateFormatter }

export default {
  methods: {
    dateFormatter,
    dateToMonthYearFormatter
  }
}
